(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("classnames"), require("../icon"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["classnames", "../icon", "react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("classnames"), require("../icon"), require("react")) : factory(root["classnames"], root["../icon"], root["React"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE_classnames__, __WEBPACK_EXTERNAL_MODULE_rcm_mobile_components_icon__, __WEBPACK_EXTERNAL_MODULE_react__) {
return 